import type { FormControl } from '@angular/forms';
import { Validators, type AbstractControl, type ValidationErrors, type ValidatorFn } from '@angular/forms';

export function PatternValidator(pattern: RegExp, error: string): ValidatorFn {
    const vali = Validators.pattern(pattern);
    return (control: AbstractControl): ValidationErrors | null => {
        if (!vali(control)) {
            return null;
        }
        return { pattern: error };
    };
}

export function URLValidator(error: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) {
            return null;
        }
        try {
            const url = new URL(control.value);
            if (url.protocol === 'http:' || url.protocol === 'https:') {
                return null;
            }
        } catch {
            /**/
        }
        return { url: error };
    };
}

export function MinLengthArrayValidator(minLength: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) {
            return null;
        }
        if (control.value.length < minLength) {
            return {
                minLengthArray: {
                    minLength,
                    actualLength: control.value.length,
                },
            };
        }
        return null;
    };
}

export function numericValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) {
            return null;
        }
        const valid = /^\d*$/.test(control.value);
        return valid ? null : { numeric: true };
    };
}

export function futureDateValidator(): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        if (!control.value) {
            return null;
        }
        if (!(control.value instanceof Date)) {
            return { invalidDate: true };
        }
        const currentDate = new Date();
        if (control.value <= currentDate) {
            return { invalidDate: true };
        }
        return null;
    };
}

export function getErrorMessage(control: FormControl, controlName: string, errorMessage?: string): string {
    if (control.hasError('required')) {
        return requiredMessages[controlName] ?? errorMessage ?? 'Dieses Feld ist erforderlich';
    }
    if (control.hasError('email')) {
        return 'Bitte geben Sie eine gültige E-Mail-Adresse ein';
    }
    if (control.hasError('numeric')) {
        return 'Ungültiges Format';
    }
    if (control.hasError('maxlength')) {
        const maxLength = control.getError('maxlength')?.requiredLength;
        return `Die maximale Länge beträgt ${maxLength} Zeichen`;
    }
    return '';
}

const requiredMessages: Record<string, string> = {
    firstName: 'Bitte geben Sie Ihren Vornamen ein',
    lastName: 'Bitte geben Sie Ihren Nachnamen ein',
    message: 'Bitte geben Sie eine Nachricht ein',
    email: 'Bitte geben Sie Ihre E-Mail-Adresse ein',
    phone: 'Bitte geben Sie Ihre Telefonnummer ein',
    dealer: 'Bitte wählen Sie einen Händler aus',
    topic: 'Bitte wählen Sie ein Thema aus',
    numberplate: 'Bitte geben Sie Ihr Kennzeichen ein',
    mileage: 'Bitte geben Sie den Kilometerstand an',
    firstReg: 'Bitte geben Sie das Datum der Erstzulassung an',
    name: 'Bitte geben Sie Ihren Namen ein',
    wishtime: 'Bitte wählen Sie die gewünschte Tageszeit aus',
};
